// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable react/style-prop-object */ /* eslint-disable max-len */
import React from 'react';
import { H1 } from '../../components/Custom/Typography/Typography';
import { getPrivacyPolicyPath } from '../../constants/routes';

const CookiePolicyId: React.FC = () => (
  <div className="px-10 py-10">
    <p align="center">
      <H1>
        <strong>
          PEMBERITAHUAN&nbsp;
          <em>COOKIE</em>
        </strong>
      </H1>
    </p>
    <p align="center">
      <strong>Tanggal efektif: </strong>
      <span>11 Desember 2025</span>
    </p>
    <br />
    <p align="justify">
      Pemberitahuan
      {' '}
      <em>Cookie</em>
      {' '}
      ini menjelaskan bagaimana kami,
      {' '}
      <strong>PT Multifinance Anak Bangsa</strong>
      {' '}
      (selanjutnya disebut sebagai “Kami”), menggunakan teknologi pelacakan di situs web dan/atau aplikasi kami (secara bersama-sama disebut sebagai “Platform”). Pemberitahuan
      {' '}
      <em>Cookie</em>
      {' '}
      ini berlaku untuk semua pengunjung dan pengguna (“Anda”) dari Platform tersebut.
    </p>
    <p>Kami menguraikan di bawah ini informasi tentang:</p>
    <ul className="list-disc ml-10">
      <li>
        <em>Cookie</em>
        ;
      </li>
      <li>
        Bagaimana Kami menggunakan&nbsp;
        <em>cookie</em>
        ; dan
      </li>
      <li>Cara menghubungi Kami.</li>
    </ul>
    <br />
    <p>
      <strong>
        1.&nbsp;
        <em>COOKIE</em>
      </strong>
    </p>
    <p align="justify">
      <em>Cookie</em>
      {' '}
      adalah file teks kecil yang dikirim dari situs web ke komputer atau perangkat seluler Anda, di mana file tersebut disimpan oleh browser web Anda. Cookie membantu situs web mengingat informasi tentang Anda, memudahkan Anda untuk mengunjungi situs tersebut kembali.
    </p>
    <p align="justify">
      Kami hanya menggunakan
      {' '}
      <em>cookie</em>
      {' '}
      yang sangat diperlukan untuk operasi atau fungsionalitas Platform Kami, sehingga tidak perlu disesuaikan atau dinonaktifkan.
    </p>
    <p align="justify">
      Penting untuk dipahami bahwa informasi dan/atau data yang disimpan oleh cookie berada di browser web atau perangkat Anda. Jika diinginkan, Anda juga dapat memilih untuk menghapus
      {' '}
      <em>cookie</em>
      {' '}
      yang tersimpan pada browser web atau perangkat Anda melalui pengaturan browser Anda. Sebagian besar browser masa kini memungkinkan Anda menghapus
      {' '}
      <em>cookie</em>
      {' '}
      dengan membuka pengaturan browser dan memilih opsi hapus
      {' '}
      <em>cookie</em>
      .
    </p>
    <br />
    <p>
      <strong>
        2.&nbsp;BAGAIMANA KAMI MENGGUNAKAN
        <em>COOKIE</em>
      </strong>
    </p>
    <p align="justify">
      Kami hanya menggunakan
      {' '}
      <em>cookie</em>
      {' '}
      yang penggunaannya sangat diperlukan untuk operasi atau fungsionalitas Platform.
    </p>
    <br />
    <p><strong><u>Strictly Necessary Cookies</u></strong></p>
    <p align="justify">
      <em>Strictly necessary cookies</em>
      {' '}
      penting agar fitur inti Platform Kami berfungsi dengan baik.
      {' '}
      <em>Cookie</em>
      {' '}
      ini selalu disetel ke &quot;Aktif&quot; karena diperlukan untuk menyediakan layanan, aplikasi, dan fungsionalitas yang Anda minta. Berikut adalah daftar rinci
      {' '}
      <em>strictly necessary cookies</em>
      {' '}
      yang Kami gunakan di Platform web Kami serta tujuan masing-masing
      {' '}
      <em>cookie</em>
      {' '}
      yang diaktifkan:
    </p>
    <br />
    <table className="w-full border-collapse border border-gray-400">
      <thead>
        <tr className="bg-gray-100">
          <th className="border border-gray-400 px-4 py-2 text-left">
            Nama&nbsp;
            <em>Cookie</em>
          </th>
          <th className="border border-gray-400 px-4 py-2 text-left"><em>Host</em></th>
          <th className="border border-gray-400 px-4 py-2 text-left">Masa Berlaku</th>
          <th className="border border-gray-400 px-4 py-2 text-left">Jenis Layanan</th>
          <th className="border border-gray-400 px-4 py-2 text-left">Deskripsi</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="border border-gray-400 px-4 py-2">acw_tcw</td>
          <td className="border border-gray-400 px-4 py-2">merchantlending.mab.co.id</td>
          <td className="border border-gray-400 px-4 py-2"><em>Persistent</em></td>
          <td className="border border-gray-400 px-4 py-2">Pihak Pertama</td>
          <td className="border border-gray-400 px-4 py-2">Berguna untuk melindungi situs dari aktivitas mencurigakan dan serangan siber.</td>
        </tr>
      </tbody>
    </table>
    <br />
    <p><strong>3.&nbsp;CARA MENGHUBUNGI KAMI</strong></p>
    <p align="justify">
      Perubahan pada Pemberitahuan
      {' '}
      <em>Cookie</em>
      {' '}
      ini akan diposting di sini. Silakan periksa halaman ini secara berkala agar tetap terinformasi tentang pembaruan apa pun. Jika Anda memiliki pertanyaan tentang Pemberitahuan
      {' '}
      <em>Cookie</em>
      {' '}
      ini, silakan hubungi Kami melalui informasi kontak kami yang terdapat di dalam
      &nbsp;
      <a
        href={getPrivacyPolicyPath('id')}
        className="underline text-blue-600 hover:text-blue-800"
        target="_blank"
        rel="noopener noreferrer"
      >
        Pemberitahuan Privasi
      </a>
      &nbsp;kami.
    </p>
  </div>
);

export default CookiePolicyId;